import { Col, Container, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
// import handleViewport from "react-in-viewport";
import Image from "next/image";
import { toWebp } from "../../../utils/common";
import styles from "./style.module.scss";

const Brand = (props) => {

  const data = props.block;
  const inViewport = true;
  // const { forwardedRef, inViewport, data } = props;
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;
  const [height, setHeight] = useState();

  useEffect(() => {
    const setView = () => {
      if (window?.innerWidth > 1400) {
        setHeight(550);
      } else {
        setHeight(500);
      }
    };
    setView();

    window.addEventListener("resize", setView);
    return () => {
      window.addEventListener("resize", setView);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section
      // ref={forwardedRef}
      className={`${styles["brand-section"]} bg-one home-padding-new`}
      style={{ minHeight: `${height}px` }}
    >
      {inViewport && (
        <Container className={styles['container']}>
          <Row>
            <Col lg={12}>
              <div className={styles["brand-content"]}>
                <h2 className="text-black">{data.title}</h2>
              </div>
            </Col>
            <Col lg={12}>
              <Row className={styles["clientbox-content"]}>
                {data?.logos?.data &&
                  data?.logos?.data.map((logo, i) => {
                    return (
                      <Col key={i} lg={3} md={3} sm={4} xs={4}>
                        <div className={`${styles["brand-compeny-card"]} border-2 border-color bg-white`}>
                          <Image
                            height={100}
                            width={100}
                            alt={logo?.attributes?.name || "Brand"}
                            src={
                              logo?.attributes?.url
                                ? toWebp(`${baseUrl}${logo?.attributes?.url}`)
                                : null
                            }
                          />
                        </div>
                      </Col>
                    );
                  })}
              </Row>
            </Col>

          </Row>
          {data?.buttons &&
            <Row style={{ justifyContent: "center" }} >
              <Col lg={12}>
                <a  className={`${styles['brandbtn']}  btn btn-primary`}  style={{margin: "0px auto"}}  href={data?.buttons?.href}>{data?.buttons?.label}</a>
              </Col>
            </Row>
          }

        </Container>
      )}
    </section>
  );
};
// const BrandViewportBlock = handleViewport(Brand);

export default Brand;
